import React from 'react';
import Helmet from 'react-helmet';
import View from '../components/View';
import ServiceView from '../components/ServiceView';
import IndexSecondView from '../components/IndexSecondView';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';
import pictureShowcase from './assets/img/picture_showcase.png';

const title = 'Sites vitrine';
const description = `


Un site internet est la base de toute **communication digitale**. C’est le seul média web sur lequel vous avez un **contrôle total**. Contrairement aux autres sites par lesquels vous communiquez peut être déjà comme les réseaux sociaux ou les annuaires/comparateurs comme Booking, TripAdvisor et bien d'autres. C’est pour cela que nous ne nous contentons pas de personnaliser des solutions déjà existantes mais que nous **façonnons votre site web de zéro**. Quoi de mieux pour communiquer vos valeurs qu’un site internet **totalement à votre image**.

### Comment produisons-nous pour vous ce fameux site internet vitrine idéal :
-   **Un entretien** pendant lequel nous en apprenons plus sur vous, votre activité et vos besoins.
-   **Une maquette graphique** par un graphiste expérimenté pour un site web design et sur-mesure.
-   Après votre feu vert sur la maquette, nous développons le site vitrine avec des **technologies modernes et performantes** que ce soit pour une navigation rapide ou pour un bon référencement pour une présence en ligne accrue sur les moteurs de recherche.
-   Le développement de votre site terminé, nous l’hébergeons chez un gros **hébergeur français** parce qu’on est un peu chauvain, mais aussi parce que c’est un des meilleurs mondiaux et qu’un site internet en ligne en tout temps c’est mieux.
-   On vous fournis une **interface web** vous permettant de modifier, ajouter ou supprimer du contenu à tout instant, un **CMS** (Content Management System) pour les connaisseurs. Ce CMS n’est pas un vulgaire Wordpress mais une interface que nous avons configuré pour vous pour que gérer le contenu de votre site web soit une tâche simple et rapide.
-   Votre tout nouveau site vitrine est en ligne mais nous ne vous quittons pas là. En plus d’assurer la maintenance de votre nouveau site internet, nous avons à coeur d’avoir une **relation client humaine** et disponible donc nous serons toujours disponible que ce soit par mail ou téléphone pour vos questions ou vos nouveaux projets digitaux. On est là depuis 2001 et on ne compte pas disparaître de si tôt.
Que vous soyez déjà conquis ou encore perplexe n’hésitez pas à nous contacter par téléphone, mail, chat ou carte postale, nous serons heureux de discuter avec vous de votre **communication numérique** ou tout autre projet informatique. **On vous attend !**
`;
const technos = ['React', 'Gatsby', 'Javascript'];
const IndexPage = (props) => {
  const {
    data: {
      previewProjects,
    },
  } = props;
  return (
    <div>
      <Helmet
        meta={[
          {
            name: 'description',
            content: 'Création de sites internet, site vitrine, blog et portfolio de qualité premium.',
          },
        ]}
      />
      <View colorMode="2">
        <ServiceView
          picture={pictureShowcase}
          title={title}
          description={description}
          technologies={technos}
        />
        <IndexSecondView data={previewProjects} />
        <ContactView />
        <FooterView />
      </View>
    </div>

  );
};

export default IndexPage;

export const query = graphql`
  query sitevitrine {
    previewProjects: allDatoCmsArticle(limit: 3, sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "project"},
      tag: {eq: "site vitrine"}
    }) {
      ...previewArticle
    }
  }
  `;



// WEBPACK FOOTER //
// ./src/pages/sites-vitrine.jsx